import React from 'react'
import { Form, Input } from 'antd'

function IdNumber() {

	return <div className='textarea-holder'><Form.Item
		name={['metadata', 'idCard', 'idNumber']}
		label={'ЕГН'}
		className='input-box'
	>
		<Input
			className='input'
		/>
	</Form.Item>
	</div>
}

export default IdNumber
